module.exports = __webpack_public_path__ + "static/after3-3dcca8d25865694e3e4ad7a3f8e5855c.jpg";